module.exports = function AssertionString(text) {
  this.text = text;
};
